/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { GetApprovalRowResponse } from '../models/get-approval-row-response';
import { CreateApprovalRowRequest } from '../models/create-approval-row-request';
import { UpdateApprovalRowRequest } from '../models/update-approval-row-request';
@Injectable({
  providedIn: 'root',
})
class ApprovalRowService extends __BaseService {
  static readonly ApprovalRowGetAllPath = '/ApprovalRow/GetAll';
  static readonly ApprovalRowGetByIdPath = '/ApprovalRow/GetById';
  static readonly ApprovalRowCreatePath = '/ApprovalRow/Create';
  static readonly ApprovalRowCreateRangePath = '/ApprovalRow/CreateRange';
  static readonly ApprovalRowUpdatePath = '/ApprovalRow/Update';
  static readonly ApprovalRowDeletePath = '/ApprovalRow/Delete';
  static readonly ApprovalRowDeleteRangePath = '/ApprovalRow/DeleteRange';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }
  ApprovalRowGetAllResponse(): __Observable<__StrictHttpResponse<Array<GetApprovalRowResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/ApprovalRow/GetAll`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<GetApprovalRowResponse>>;
      })
    );
  }  ApprovalRowGetAll(): __Observable<Array<GetApprovalRowResponse>> {
    return this.ApprovalRowGetAllResponse().pipe(
      __map(_r => _r.body as Array<GetApprovalRowResponse>)
    );
  }

  /**
   * @param Id undefined
   */
  ApprovalRowGetByIdResponse(Id?: string): __Observable<__StrictHttpResponse<GetApprovalRowResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Id != null) __params = __params.set('Id', Id.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/ApprovalRow/GetById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GetApprovalRowResponse>;
      })
    );
  }
  /**
   * @param Id undefined
   */
  ApprovalRowGetById(Id?: string): __Observable<GetApprovalRowResponse> {
    return this.ApprovalRowGetByIdResponse(Id).pipe(
      __map(_r => _r.body as GetApprovalRowResponse)
    );
  }

  /**
   * @param request undefined
   */
  ApprovalRowCreateResponse(request: CreateApprovalRowRequest): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/ApprovalRow/Create`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  ApprovalRowCreate(request: CreateApprovalRowRequest): __Observable<Blob> {
    return this.ApprovalRowCreateResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param request undefined
   */
  ApprovalRowCreateRangeResponse(request: Array<CreateApprovalRowRequest>): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/ApprovalRow/CreateRange`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  ApprovalRowCreateRange(request: Array<CreateApprovalRowRequest>): __Observable<Blob> {
    return this.ApprovalRowCreateRangeResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param request undefined
   */
  ApprovalRowUpdateResponse(request: UpdateApprovalRowRequest): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/ApprovalRow/Update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  ApprovalRowUpdate(request: UpdateApprovalRowRequest): __Observable<Blob> {
    return this.ApprovalRowUpdateResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param id undefined
   */
  ApprovalRowDeleteResponse(id?: string): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (id != null) __params = __params.set('id', id.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/ApprovalRow/Delete`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param id undefined
   */
  ApprovalRowDelete(id?: string): __Observable<Blob> {
    return this.ApprovalRowDeleteResponse(id).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param ids undefined
   */
  ApprovalRowDeleteRangeResponse(ids: Array<string>): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = ids;
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/ApprovalRow/DeleteRange`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param ids undefined
   */
  ApprovalRowDeleteRange(ids: Array<string>): __Observable<Blob> {
    return this.ApprovalRowDeleteRangeResponse(ids).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module ApprovalRowService {
}

export { ApprovalRowService }
